<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中" >

    <div style="text-align: center;margin-top: 40%;font-size: 36px;">快递签收</div>
    <el-form class="search-box" ref="form" :model="form" :rules="rules" style="margin:10px 0!important;">
      <el-form-item prop="shipping_no">
        <el-input
            ref="search"
            @focus="stopKeyborad"
            @blur="stopKeyborad"
            v-model="form.shipping_no"
            @keydown.enter.native.prevent="onSubmit"
            placeholder="扫描物流单号"
        >
          <el-button
              @click.prevent="onSubmit"
              slot="append"
              icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: center;font-size: 12px;margin-top: 10px;color:#575252">如需返回上一级界面，请点击左上角按钮，并选择返回上一页</div>
  </div>
</template>

<script>
export default {
  name: "Check",
  data() {
    return {
      user_info:JSON.parse(localStorage.getItem('user_info')),
      remove_order: '',
      loading: false,
      form: {
        shipping_no: ""
      },
      rules: {
        shipping_no: [
          {required: true, message: "请扫描物流单号", trigger: "blur"},
        ],
      },
    }
  },
  methods: {

    onSubmit() {
      var user_id = this.user_info.id;
      var depot = this.user_info.depot;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          var param = {
            shipping_no:this.form.shipping_no,
            user_id:user_id,
            depot:depot
          }
          this.http.fetchPost(this.api.upDelivery, param).then((res) => {
            let data = res.data

            if (data.code === 200) {
              this.$message.success('登记成功');
              this.form.shipping_no = ""
              this.onfocusEvent()
            }else{
              this.$message.error(data.data);
              this.form.shipping_no = ""
              this.onfocusEvent()
            }
            this.loading = false
          }).catch((err) => {
            console.log(err);
            this.form.shipping_no = ""
            this.onfocusEvent()
            this.$message.error('扫描物流单号错误');
            this.loading = false
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },

  },
  computed: {

  },
  //被 keep-alive 缓存的组件失活时调用
  deactivated(){
    this.$EventBus.$emit('order', this.bus_item);
  },
  //被 keep-alive 缓存的组件激活时调用
  activated(){
    this.onfocusEvent()
  },

}
</script>

<style scoped lang="stylus">
.not_click{
  background-color: #e8e8e8;
}
.status_tips{
  position: absolute;
  color: red;
  top: 2px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.status_card{
  position: absolute;
  color: red;
  bottom: 5px;
  right: 17px;
  border: 1px solid red;
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;
  font-size: 28px;
}
.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px

@media (max-width: 720px) {


}

</style>
